import type { SxProps, Theme } from '@mui/system';

export const styles: Record<string, SxProps<Theme>> = {
  dialogContent: {
    pt: 1,
  },
  layout: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  evidenceColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  panelColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    pt: 1,
  },
  dropzone: {
    border: '2px dashed',
    borderColor: 'divider',
    borderRadius: 1,
    p: 3,
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'border-color 120ms',
    '&:hover': { borderColor: 'primary.main' },
  },
  acceptedFileChip: {
    mt: 1,
    fontSize: 12,
    textAlign: 'center',
  },
  message: {
    color: 'text.secondary',
    fontSize: 14,
  },
  searchRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    mb: 1,
  },
  dataGridContainer: {
    flex: 1,
    minHeight: 400,
  },
};
